/**
 * @todo
 * - Use HiddenResource exception
 * - Evaluate move to compile.js
 * - Improve error handling
 *
 * @module
 */
import { HTMLTemplateElement, isInstanceOf } from "@acng/frontend-bounty/types.js";
import { addClass, classList, cloneNode, createElement, hasClass, hasDataAttribute, parentElement, replace as replaceNode, setText, } from "@acng/frontend-bounty";
import { UUID_STARGAZER_LOADER } from "../model/resource.js";
import { rootNamespace } from "./root.js";
import { lookup } from "./lookup.js";
import { render } from "./render.js";
/**
 * @param {import("../model/resource.js").ResourceElement} resource
 * @param {ChildNode} childNode
 * @param {string[]} path
 *
 * @param {Record<string, string> | undefined} replacements
 * TODO RenderHost
 *
 * @returns {Promise<void>}
 * The path of the included (or hidden) resource to be used for {@link Dependencies}.
 */
export const replace = async (resource, childNode, path, replacements) => {
    try {
        const childResource = await lookup(rootNamespace, path);
        const template = replacements ? render(childResource, replacements) : cloneNode(childResource);
        const relevantParentElement = parentElement(childNode) ?? resource;
        DEBUG: if (hasDataAttribute(resource, "debug")) {
            for (const token of classList(template)) {
                if (!hasClass(relevantParentElement, token)) {
                    console.warn("Adding missing classes to relevant parent element to satisfy css constraint.", {
                        resource,
                        relevantParentElement,
                        template,
                    });
                    break;
                }
            }
        }
        // Add the template classList to the parent element OR to the template element.
        addClass(relevantParentElement, ...classList(template));
        replaceNode(childNode, template.content);
    }
    catch (reason) {
        if (isInstanceOf(reason, HTMLTemplateElement)) {
            return;
        }
        console.error(UUID_STARGAZER_LOADER, { reason, resource, childNode });
        // Add some verbose stuff to the resource because some devs do not read console output.
        // resource `path` not found, which is included in `resource`
        const errorElement = createElement("strong");
        Object.assign(errorElement.style, {
            background: "#000",
            border: "2px dashed #ff0",
            outline: "2px solid #000",
            color: "#ff0",
            padding: "5px 10px",
            "border-radius": "5px",
        });
        setText(errorElement, `🚧 ${childNode.textContent} 🚧`);
        replaceNode(childNode, errorElement);
    }
    //DEBUG: return {path: path.join("."), replacements};
};
